module.exports = __webpack_public_path__ + "img/step12_b_basket_basic_clip_tubes.faea4810.png";